<template>
  <div
    class="deposit-models"
    :class="{ 'is-scrolled': isScrollable && !isScrolledToEnd }"
    ref="depositmodels"
    v-resize:debounce.50="updateScrollableState"
  >
    <h4 class="deposit-models__label">
      {{ $t("global.deposit-model-options") }}
    </h4>
    <div
      class="deposit-models__content"
      ref="depositmodelcontent"
      @scroll="onScroll"
    >
      <div
        class="deposit-model-wrap"
        v-for="(model, index) in depositModels"
        v-bind:key="index"
      >
        <div class="deposit-model" :class="{ 'is-inactive': !model.active }">
          <div class="deposit-model__icon">
            <svg width="64" height="64">
              <use v-bind:xlink:href="getDepotsitModelIcon(model.name)" />
            </svg>
          </div>
          <span class="deposit-model__name" v-if="window.width >= 600">{{
            $t(`depositmodels.${model.name}.name`)
          }}</span>
          <span class="deposit-model__name" v-else>{{
            $t(`depositmodels.${model.name}.shortname`)
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize from "vue-resize-directive";

export default {
  directives: {
    resize
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      isScrollable: false,
      isScrolledToEnd: false
    };
  },
  computed: {
    depositModels() {
      return this.$store.getters.getFilteredDepositModels;
    }
  },
  methods: {
    getDepotsitModelIcon(model) {
      return "#icon-" + model.toLowerCase();
    },
    isElementScrollable(el) {
      let curOverflow = el.style.overflow;

      if (!curOverflow || curOverflow === "visible")
        el.style.overflow = "hidden";
      let isOverflowing =
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

      el.style.overflow = curOverflow;

      return isOverflowing;
    },
    isElementScrolledToEnd(el) {
      let elementScrollWidth = el.scrollWidth;
      let elementWidth = el.clientWidth;
      let x = el.scrollLeft;
      let offset = 5;
      return x + offset + elementWidth >= elementScrollWidth;
    },
    updateScrollableState() {
      this.isScrollable = this.isElementScrollable(
        this.$refs.depositmodelcontent
      );
    },
    onScroll() {
      this.isScrolledToEnd = this.isElementScrolledToEnd(
        this.$refs.depositmodelcontent
      );
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  updated() {
    this.updateScrollableState();
  },
  mounted() {
    this.updateScrollableState();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
